import AimsArrangeList from './src/arrange-list'
import AimsArrangeTable from './src/arrange-table'
import AimsWaitList from './src/wait-list'
import AimsOperationEdit from './src/operation-edit'
import AimsOperationInfo from './src/operation-info'
import AimsOperationSelection from './src/operation-selection'
import AimsPrintList from './src/print-list'
import AimsSigningEdit from './src/signing-edit'
import AimsOperationBaseInfo from "./src/operation-base-info"

const components = [
    AimsArrangeList,
    AimsArrangeTable,
    AimsOperationEdit,
    AimsOperationSelection,
    AimsOperationInfo,
    AimsPrintList,
    AimsSigningEdit,
    AimsOperationBaseInfo
]

const install = function (Vue) {
    components.map(component => {
        Vue.component(component.name, component)
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default {
    version: '1.0.1',
    name: 'EberAims',
    install,
    AimsArrangeList,
    AimsArrangeTable,
    AimsWaitList,
    AimsOperationEdit,
    AimsOperationSelection,
    AimsOperationInfo,
    AimsPrintList,
    AimsSigningEdit,
    AimsOperationBaseInfo
}
